export default {
  isLoading: (state) => state.loading,
  sort: (state) => state.sort,
  filters: (state) => state.filters,
  search: (state) => state.search,
  paramsQuery: (state) => ({ ...state.filters, search: state.search }),
  range: (state) => state.range,
  items: (state) => state.items,
  total: (state) => state.total,
}
